"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MethodFiPaymentStatus = exports.MethodFiLiabilityAccountType = void 0;
// TODO(xuemeiliu): Deprecate MethodFiLiabilityAccountType in aven_backend/src/provider/MethodFi/methodFiProvider.types.ts
/* @TranslateToPython */
var MethodFiLiabilityAccountType;
(function (MethodFiLiabilityAccountType) {
    MethodFiLiabilityAccountType["_student_loan_deprecated"] = "student_loan";
    MethodFiLiabilityAccountType["student_loan"] = "student_loans";
    MethodFiLiabilityAccountType["credit_card"] = "credit_card";
    MethodFiLiabilityAccountType["auto_loan"] = "auto_loan";
    MethodFiLiabilityAccountType["mortgage"] = "mortgage";
    MethodFiLiabilityAccountType["personal_loan"] = "personal_loan";
    MethodFiLiabilityAccountType["loan"] = "loan";
    MethodFiLiabilityAccountType["utility"] = "utility";
    MethodFiLiabilityAccountType["insurance"] = "insurance";
    MethodFiLiabilityAccountType["credit_builder"] = "credit_builder";
    MethodFiLiabilityAccountType["collection"] = "collection";
    MethodFiLiabilityAccountType["business_loan"] = "business_loan";
    MethodFiLiabilityAccountType["_unknown"] = "unknown";
})(MethodFiLiabilityAccountType || (exports.MethodFiLiabilityAccountType = MethodFiLiabilityAccountType = {}));
// The 'status' attribute of a MethodFi payment object representing the payment status.
// https://docs.methodfi.com/api/core/payments/object
// Prepended the MethodFi prefix to avoid name collisions with other enums
var MethodFiPaymentStatus;
(function (MethodFiPaymentStatus) {
    MethodFiPaymentStatus["MethodFiPending"] = "pending";
    MethodFiPaymentStatus["MethodFiProcessing"] = "processing";
    MethodFiPaymentStatus["MethodFiSent"] = "sent";
    MethodFiPaymentStatus["MethodFiPosted"] = "posted";
    MethodFiPaymentStatus["MethodFiFailed"] = "failed";
    MethodFiPaymentStatus["MethodFiCanceled"] = "canceled";
    MethodFiPaymentStatus["MethodFiReversalRequired"] = "reversal_required";
    MethodFiPaymentStatus["MethodFiReversalProcessing"] = "reversal_processing";
    MethodFiPaymentStatus["MethodFiReversed"] = "reversed";
    MethodFiPaymentStatus["MethodFiSettled"] = "settled";
})(MethodFiPaymentStatus || (exports.MethodFiPaymentStatus = MethodFiPaymentStatus = {}));
